// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".not-subscribed-caption[data-v-03590d00]{margin-bottom:20px;text-align:center}.margin[data-v-03590d00]{margin-bottom:20px;margin-top:20px}", ""]);
// Exports
module.exports = exports;
